import { message } from 'antd'
import {
  ProjectMemberEntity,
  DetailProjectMemberInput,
  CreateProjectMemberInput,
  ListProjectMemberByProjectInput,
  BodyUpdateProjectMemberIdWithInputInput,
  ListProjectMemberNotInTaskInput,
} from '../../../../../../server-api-hrm.type'
import axiosClient from '../../../../../../utils/custom-fetch'
import { MetadataType } from '../../../../../../utils/metadata.types'
import { URL_ENDPOINT_PROJECT_MEMBER } from './constants/config.project-member'

const appEndpoint = URL_ENDPOINT_PROJECT_MEMBER

export const getListProjectMember = async (
  token?: string,
  body?: Partial<ListProjectMemberByProjectInput>
) => {
  if (!token || !body?.projectId) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<{
      metadata: MetadataType
      data: ProjectMemberEntity[]
    }>(`${appEndpoint}/list/by-project`, body)
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const getListProjectMemberNotInTask = async (
  token?: string,
  body?: Partial<ListProjectMemberNotInTaskInput>
) => {
  if (!token || !body?.taskId) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<{
      metadata: MetadataType
      data: ProjectMemberEntity[]
    }>(`${appEndpoint}/list/not-in-task`, body)
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const getDetailProjectMember = async (
  token?: string,
  body?: DetailProjectMemberInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ProjectMemberEntity>(
      `${appEndpoint}/detail`,
      body
    )
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const addProjectMember = async (
  token?: string,
  body?: CreateProjectMemberInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ProjectMemberEntity>(
      `${appEndpoint}/add`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}

export const updateProjectMember = async (
  token?: string,
  body?: BodyUpdateProjectMemberIdWithInputInput
) => {
  if (!body?.id || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ProjectMemberEntity>(
      `${appEndpoint}/update`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}

export const deleteProjectMember = async (
  token?: string,
  body?: DetailProjectMemberInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ProjectMemberEntity>(
      `${appEndpoint}/delete`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}
